import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PardotForm } from '@periscopes/general/pardot-forms';
import { MetadataContainer } from '@periscopes/general/metadata';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useMemo } from 'react';
import { usePeriscopeActions, usePeriscopeMetadata } from '@hooks';
export const PardotLandingPageMetadataTab = ({ index, sonarObjectId }) => {
    const { openPeriscope } = usePeriscopeActions();
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.PardotLandingPage);
    const handleFormClick = useCallback(() => {
        var _a, _b;
        if (!((_a = metadata === null || metadata === void 0 ? void 0 : metadata.form) === null || _a === void 0 ? void 0 : _a.sonarObjectId)) {
            return;
        }
        const { form } = metadata;
        openPeriscope({
            id: form.sonarObjectId,
            name: form.displayName,
            openedFromIndex: index,
            type: (_b = form.sonarObjectType) !== null && _b !== void 0 ? _b : SonarObjectType.PardotForm
        });
    }, [index, openPeriscope, metadata]);
    const metadataEntries = useMemo(() => {
        if (!metadata) {
            return [];
        }
        const entries = [
            {
                label: COPY_SPECIFIC.CAMPAIGN,
                type: 'string',
                value: metadata.campaign
            },
            {
                label: COPY_SPECIFIC.TITLE,
                type: 'string',
                value: metadata.title
            },
            {
                label: COPY_SPECIFIC.LINK,
                type: 'string',
                value: metadata.link
            }
        ];
        return entries;
    }, [metadata]);
    if (loading || !metadata) {
        return React.createElement(LoadingSpinner, { spinning: true });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.LANDING_PAGE_INFORMATION }),
        metadata.form && React.createElement(PardotForm, { entity: metadata.form, onFormClick: handleFormClick })));
};
